{
  "Squire": {
    "M": {
      "hp": 183,
      "mp": 55,
      "pa": 9,
      "ma": 7,
      "speed": 9,
      "move": 4,
      "jump": 3,
      "cEv": 8,
      "innate": [
        "Basic Skill"
      ],
      "weapons": {
        "Sword": 40,
        "Crossbow": 25,
        "Axe": 18,
        "Flail": 18
      },
      "heads": [
        "Hat",
        "Helmet"
      ],
      "bodies": [
        "Clothing",
        "Armor"
      ],
      "shield": true,
      "equipArms": {
        "Knife": {
          "Ninja Blade": 36,
          "Knife": 36,
          "Rod": 29
        },
        "Sword": {
          "Katana": 37,
          "Knight Sword": 35,
          "Sword": 29
        },
        "Axe": {
          "Staff": 46,
          "Axe": 27,
          "Flail": 27
        },
        "Polearm": {
          "Spear": 43,
          "Pole": 43,
          "Fabric": 15
        },
        "Bow": {
          "Bow": 64,
          "Crossbow": 35,
          "Bag": 1
        },
        "Gun": {
          "Gun": 47,
          "Book": 39,
          "Harp": 15
        }
      },
      "notes": "Excluding PreferredArms does nothing if you get an EquipWeapon skill, on every class."
    },
    "F": {
      "hp": 171,
      "mp": 59,
      "pa": 7,
      "ma": 9,
      "speed": 9,
      "move": 4,
      "jump": 3,
      "cEv": 8,
      "innate": [
        "Basic Skill"
      ],
      "weapons": {
        "Sword": 40,
        "Crossbow": 25,
        "Axe": 18,
        "Flail": 18
      },
      "heads": [
        "Hat",
        "Helmet"
      ],
      "bodies": [
        "Clothing",
        "Armor"
      ],
      "shield": true,
      "equipArms": {
        "Knife": {
          "Ninja Blade": 36,
          "Knife": 36,
          "Rod": 29
        },
        "Sword": {
          "Katana": 37,
          "Knight Sword": 35,
          "Sword": 29
        },
        "Axe": {
          "Staff": 46,
          "Axe": 27,
          "Flail": 27
        },
        "Polearm": {
          "Spear": 43,
          "Pole": 43,
          "Fabric": 15
        },
        "Bow": {
          "Bow": 64,
          "Crossbow": 35,
          "Bag": 1
        },
        "Gun": {
          "Gun": 47,
          "Book": 39,
          "Harp": 15
        }
      },
      "notes": "Excluding PreferredArms does nothing if you get an EquipWeapon skill, on every class."
    }
  },
  "Chemist": {
    "M": {
      "hp": 165,
      "mp": 46,
      "pa": 7,
      "ma": 7,
      "speed": 8,
      "move": 3,
      "jump": 3,
      "cEv": 12,
      "innate": [
        "Item",
        "Throw Item"
      ],
      "weapons": {
        "Bag": 50,
        "Knife": 25,
        "Gun": 25,
        "Sword": 1
      },
      "heads": [
        "Hat"
      ],
      "bodies": [
        "Clothing"
      ],
      "shield": false,
      "equipArms": {
        "Knife": {
          "Ninja Blade": 36,
          "Rod": 36,
          "Knife": 29
        },
        "Sword": {
          "Katana": 38,
          "Sword": 35,
          "Knight Sword": 26
        },
        "Axe": {
          "Axe": 36,
          "Flail": 36,
          "Staff": 29
        },
        "Polearm": {
          "Spear": 43,
          "Pole": 43,
          "Fabric": 15
        },
        "Bow": {
          "Bow": 64,
          "Crossbow": 35,
          "Bag": 1
        },
        "Gun": {
          "Book": 43,
          "Gun": 29,
          "Harp": 29
        }
      },
      "notes": "Excluding PreferredArms does nothing if you get an EquipWeapon skill, on every class."
    },
    "F": {
      "hp": 154,
      "mp": 49,
      "pa": 6,
      "ma": 8,
      "speed": 8,
      "move": 3,
      "jump": 3,
      "cEv": 12,
      "innate": [
        "Item",
        "Throw Item"
      ],
      "weapons": {
        "Bag": 50,
        "Knife": 25,
        "Gun": 25,
        "Sword": 1
      },
      "heads": [
        "Hat"
      ],
      "bodies": [
        "Clothing"
      ],
      "shield": false,
      "equipArms": {
        "Knife": {
          "Ninja Blade": 36,
          "Rod": 36,
          "Knife": 29
        },
        "Sword": {
          "Katana": 38,
          "Sword": 35,
          "Knight Sword": 26
        },
        "Axe": {
          "Axe": 36,
          "Flail": 36,
          "Staff": 29
        },
        "Polearm": {
          "Spear": 43,
          "Pole": 43,
          "Fabric": 15
        },
        "Bow": {
          "Bow": 64,
          "Crossbow": 35,
          "Bag": 1
        },
        "Gun": {
          "Book": 43,
          "Gun": 29,
          "Harp": 29
        }
      },
      "notes": "Excluding PreferredArms does nothing if you get an EquipWeapon skill, on every class."
    }
  },
  "Knight": {
    "M": {
      "hp": 202,
      "mp": 42,
      "pa": 12,
      "ma": 6,
      "speed": 8,
      "move": 3,
      "jump": 3,
      "cEv": 14,
      "innate": [
        "Battle Skill",
        "Equip Shield"
      ],
      "weapons": {
        "Knight Sword": 38,
        "Sword": 42,
        "Axe": 20
      },
      "heads": [
        "Helmet"
      ],
      "bodies": [
        "Armor",
        "Robe"
      ],
      "shield": true,
      "equipArms": {
        "Knife": {
          "Ninja Blade": 36,
          "Knife": 36,
          "Rod": 29
        },
        "Sword": {
          "Katana": 44,
          "Sword": 32,
          "Knight Sword": 23
        },
        "Axe": {
          "Flail": 43,
          "Axe": 29,
          "Staff": 29
        },
        "Polearm": {
          "Spear": 57,
          "Pole": 29,
          "Fabric": 15
        },
        "Bow": {
          "Bow": 50,
          "Crossbow": 50,
          "Bag": 1
        },
        "Gun": {
          "Gun": 45,
          "Book": 41,
          "Harp": 15
        }
      },
      "notes": "PreferredArms will force a Knight Sword if no equip skill is rolled.",
      "preferredArmsForce": "Knight Sword"
    },
    "F": {
      "hp": 189,
      "mp": 45,
      "pa": 10,
      "ma": 7,
      "speed": 8,
      "move": 3,
      "jump": 3,
      "cEv": 14,
      "innate": [
        "Battle Skill",
        "Equip Shield"
      ],
      "weapons": {
        "Knight Sword": 38,
        "Sword": 42,
        "Axe": 20
      },
      "heads": [
        "Helmet"
      ],
      "bodies": [
        "Armor",
        "Robe"
      ],
      "shield": true,
      "equipArms": {
        "Knife": {
          "Ninja Blade": 36,
          "Knife": 36,
          "Rod": 29
        },
        "Sword": {
          "Katana": 44,
          "Sword": 32,
          "Knight Sword": 23
        },
        "Axe": {
          "Flail": 43,
          "Axe": 29,
          "Staff": 29
        },
        "Polearm": {
          "Spear": 57,
          "Pole": 29,
          "Fabric": 15
        },
        "Bow": {
          "Bow": 50,
          "Crossbow": 50,
          "Bag": 1
        },
        "Gun": {
          "Gun": 45,
          "Book": 41,
          "Harp": 15
        }
      },
      "notes": "PreferredArms will force a Knight Sword if no equip skill is rolled.",
      "preferredArmsForce": "Knight Sword"
    }
  },
  "Archer": {
    "M": {
      "hp": 170,
      "mp": 38,
      "pa": 11,
      "ma": 6,
      "speed": 9,
      "move": 3,
      "jump": 3,
      "cEv": 16,
      "innate": [
        "Charge"
      ],
      "weapons": {
        "Bow": 40,
        "Crossbow": 40,
        "Gun": 20
      },
      "heads": [
        "Hat",
        "Helmet"
      ],
      "bodies": [
        "Clothing"
      ],
      "shield": true,
      "equipArms": {
        "Knife": {
          "Ninja Blade": 36,
          "Knife": 36,
          "Rod": 29
        },
        "Sword": {
          "Sword": 38,
          "Katana": 37,
          "Knight Sword": 25
        },
        "Axe": {
          "Axe": 36,
          "Flail": 36,
          "Staff": 29
        },
        "Polearm": {
          "Spear": 57,
          "Pole": 29,
          "Fabric": 15
        },
        "Bow": {
          "Bow": 43,
          "Crossbow": 43,
          "Bag": 14
        },
        "Gun": {
          "Gun": 45,
          "Book": 41,
          "Harp": 15
        }
      },
      "notes": "PreferredArms will force a Bow if no equip skill is rolled.",
      "preferredArmsForce": "Bow"
    },
    "F": {
      "hp": 159,
      "mp": 41,
      "pa": 9,
      "ma": 8,
      "speed": 9,
      "move": 3,
      "jump": 3,
      "cEv": 16,
      "innate": [
        "Charge"
      ],
      "weapons": {
        "Bow": 40,
        "Crossbow": 40,
        "Gun": 20
      },
      "heads": [
        "Hat",
        "Helmet"
      ],
      "bodies": [
        "Clothing"
      ],
      "shield": true,
      "equipArms": {
        "Knife": {
          "Ninja Blade": 36,
          "Knife": 36,
          "Rod": 29
        },
        "Sword": {
          "Sword": 38,
          "Katana": 37,
          "Knight Sword": 25
        },
        "Axe": {
          "Axe": 36,
          "Flail": 36,
          "Staff": 29
        },
        "Polearm": {
          "Spear": 57,
          "Pole": 29,
          "Fabric": 15
        },
        "Bow": {
          "Bow": 43,
          "Crossbow": 43,
          "Bag": 14
        },
        "Gun": {
          "Gun": 45,
          "Book": 41,
          "Harp": 15
        }
      },
      "notes": "PreferredArms will force a Bow if no equip skill is rolled.",
      "preferredArmsForce": "Bow"
    }
  },
  "Monk": {
    "M": {
      "hp": 206,
      "mp": 52,
      "pa": 12,
      "ma": 7,
      "speed": 8,
      "move": 3,
      "jump": 4,
      "cEv": 24,
      "innate": [
        "Punch Art",
        "Martial Arts"
      ],
      "weapons": {},
      "heads": [
        "Hat"
      ],
      "bodies": [
        "Clothing"
      ],
      "shield": false,
      "equipArms": {
        "Knife": {
          "Ninja Blade": 36,
          "Knife": 36,
          "Rod": 29
        },
        "Sword": {
          "Sword": 38,
          "Katana": 37,
          "Knight Sword": 25
        },
        "Axe": {
          "Axe": 36,
          "Flail": 36,
          "Staff": 29
        },
        "Polearm": {
          "Spear": 43,
          "Pole": 43,
          "Fabric": 15
        },
        "Bow": {
          "Bow": 50,
          "Crossbow": 50
        },
        "Gun": {
          "Book": 57,
          "Gun": 29,
          "Harp": 15
        }
      },
      "notes": "MartialArts is 100% unarmed if you force it, and 50% chance to be unarmed if you get it naturally, on every class."
    },
    "F": {
      "hp": 193,
      "mp": 56,
      "pa": 10,
      "ma": 9,
      "speed": 8,
      "move": 3,
      "jump": 4,
      "cEv": 24,
      "innate": [
        "Punch Art",
        "Martial Arts"
      ],
      "weapons": {},
      "heads": [
        "Hat"
      ],
      "bodies": [
        "Clothing"
      ],
      "shield": false,
      "equipArms": {
        "Knife": {
          "Ninja Blade": 36,
          "Knife": 36,
          "Rod": 29
        },
        "Sword": {
          "Sword": 38,
          "Katana": 37,
          "Knight Sword": 25
        },
        "Axe": {
          "Axe": 36,
          "Flail": 36,
          "Staff": 29
        },
        "Polearm": {
          "Spear": 43,
          "Pole": 43,
          "Fabric": 15
        },
        "Bow": {
          "Bow": 50,
          "Crossbow": 50
        },
        "Gun": {
          "Book": 57,
          "Gun": 29,
          "Harp": 15
        }
      },
      "notes": "MartialArts is 100% unarmed if you force it, and 50% chance to be unarmed if you get it naturally, on every class."
    }
  },
  "Priest": {
    "M": {
      "hp": 177,
      "mp": 94,
      "pa": 9,
      "ma": 9,
      "speed": 9,
      "move": 3,
      "jump": 3,
      "cEv": 5,
      "innate": [
        "White Magic"
      ],
      "weapons": {
        "Staff": 67,
        "Flail": 33
      },
      "heads": [
        "Hat"
      ],
      "bodies": [
        "Clothing",
        "Robe"
      ],
      "shield": false,
      "equipArms": {
        "Knife": {
          "Rod": 43,
          "Ninja Blade": 29,
          "Knife": 29
        },
        "Sword": {
          "Sword": 38,
          "Katana": 37,
          "Knight Sword": 25
        },
        "Axe": {
          "Axe": 43,
          "Flail": 29,
          "Staff": 29
        },
        "Polearm": {
          "Spear": 43,
          "Pole": 43,
          "Fabric": 15
        },
        "Bow": {
          "Bow": 50,
          "Crossbow": 50,
          "Bag": 1
        },
        "Gun": {
          "Gun": 43,
          "Book": 43,
          "Harp": 14
        }
      },
      "notes": "Excluding PreferredArms does nothing if you get an EquipWeapon skill, on every class."
    },
    "F": {
      "hp": 166,
      "mp": 101,
      "pa": 7,
      "ma": 11,
      "speed": 9,
      "move": 3,
      "jump": 3,
      "cEv": 5,
      "innate": [
        "White Magic"
      ],
      "weapons": {
        "Staff": 67,
        "Flail": 33
      },
      "heads": [
        "Hat"
      ],
      "bodies": [
        "Clothing",
        "Robe"
      ],
      "shield": false,
      "equipArms": {
        "Knife": {
          "Rod": 43,
          "Ninja Blade": 29,
          "Knife": 29
        },
        "Sword": {
          "Sword": 38,
          "Katana": 37,
          "Knight Sword": 25
        },
        "Axe": {
          "Axe": 43,
          "Flail": 29,
          "Staff": 29
        },
        "Polearm": {
          "Spear": 43,
          "Pole": 43,
          "Fabric": 15
        },
        "Bow": {
          "Bow": 50,
          "Crossbow": 50,
          "Bag": 1
        },
        "Gun": {
          "Gun": 43,
          "Book": 43,
          "Harp": 14
        }
      },
      "notes": "Excluding PreferredArms does nothing if you get an EquipWeapon skill, on every class."
    }
  },
  "Wizard": {
    "M": {
      "hp": 137,
      "mp": 107,
      "pa": 7,
      "ma": 11,
      "speed": 8,
      "move": 3,
      "jump": 3,
      "cEv": 10,
      "innate": [
        "Black Magic"
      ],
      "weapons": {
        "Rod": 67,
        "Knife": 33
      },
      "heads": [
        "Hat"
      ],
      "bodies": [
        "Clothing",
        "Robe"
      ],
      "shield": false,
      "equipArms": {
        "Knife": {
          "Ninja Blade": 43,
          "Rod": 29,
          "Knife": 29
        },
        "Sword": {
          "Sword": 38,
          "Katana": 37,
          "Knight Sword": 25
        },
        "Axe": {
          "Axe": 43,
          "Flail": 29,
          "Staff": 29
        },
        "Polearm": {
          "Pole": 57,
          "Spear": 29,
          "Fabric": 15
        },
        "Bow": {
          "Bow": 50,
          "Crossbow": 50,
          "Bag": 1
        },
        "Gun": {
          "Gun": 43,
          "Book": 43,
          "Harp": 14
        }
      },
      "notes": "Excluding PreferredArms does nothing if you get an EquipWeapon skill, on every class."
    },
    "F": {
      "hp": 128,
      "mp": 115,
      "pa": 5,
      "ma": 14,
      "speed": 8,
      "move": 3,
      "jump": 3,
      "cEv": 10,
      "innate": [
        "Black Magic"
      ],
      "weapons": {
        "Rod": 67,
        "Knife": 33
      },
      "heads": [
        "Hat"
      ],
      "bodies": [
        "Clothing",
        "Robe"
      ],
      "shield": false,
      "equipArms": {
        "Knife": {
          "Ninja Blade": 43,
          "Rod": 29,
          "Knife": 29
        },
        "Sword": {
          "Sword": 38,
          "Katana": 37,
          "Knight Sword": 25
        },
        "Axe": {
          "Axe": 43,
          "Flail": 29,
          "Staff": 29
        },
        "Polearm": {
          "Pole": 57,
          "Spear": 29,
          "Fabric": 15
        },
        "Bow": {
          "Bow": 50,
          "Crossbow": 50,
          "Bag": 1
        },
        "Gun": {
          "Gun": 43,
          "Book": 43,
          "Harp": 14
        }
      },
      "notes": "Excluding PreferredArms does nothing if you get an EquipWeapon skill, on every class."
    }
  },
  "Time Mage": {
    "M": {
      "hp": 141,
      "mp": 103,
      "pa": 8,
      "ma": 10,
      "speed": 9,
      "move": 3,
      "jump": 3,
      "cEv": 17,
      "innate": [
        "Time Magic"
      ],
      "weapons": {
        "Staff": 60,
        "Pole": 40
      },
      "heads": [
        "Hat"
      ],
      "bodies": [
        "Clothing",
        "Robe"
      ],
      "shield": false,
      "equipArms": {
        "Knife": {
          "Rod": 43,
          "Ninja Blade": 29,
          "Knife": 29
        },
        "Sword": {
          "Sword": 38,
          "Katana": 37,
          "Knight Sword": 25
        },
        "Axe": {
          "Axe": 36,
          "Flail": 36,
          "Staff": 29
        },
        "Polearm": {
          "Spear": 43,
          "Pole": 29,
          "Fabric": 29
        },
        "Bow": {
          "Bow": 50,
          "Crossbow": 50,
          "Bag": 1
        },
        "Gun": {
          "Gun": 43,
          "Book": 43,
          "Harp": 14
        }
      },
      "notes": "Excluding PreferredArms does nothing if you get an EquipWeapon skill, on every class."
    },
    "F": {
      "hp": 132,
      "mp": 110,
      "pa": 6,
      "ma": 13,
      "speed": 9,
      "move": 3,
      "jump": 3,
      "cEv": 17,
      "innate": [
        "Time Magic"
      ],
      "weapons": {
        "Staff": 60,
        "Pole": 40
      },
      "heads": [
        "Hat"
      ],
      "bodies": [
        "Clothing",
        "Robe"
      ],
      "shield": false,
      "equipArms": {
        "Knife": {
          "Rod": 43,
          "Ninja Blade": 29,
          "Knife": 29
        },
        "Sword": {
          "Sword": 38,
          "Katana": 37,
          "Knight Sword": 25
        },
        "Axe": {
          "Axe": 36,
          "Flail": 36,
          "Staff": 29
        },
        "Polearm": {
          "Spear": 43,
          "Pole": 29,
          "Fabric": 29
        },
        "Bow": {
          "Bow": 50,
          "Crossbow": 50,
          "Bag": 1
        },
        "Gun": {
          "Gun": 43,
          "Book": 43,
          "Harp": 14
        }
      },
      "notes": "Excluding PreferredArms does nothing if you get an EquipWeapon skill, on every class."
    }
  },
  "Summoner": {
    "M": {
      "hp": 125,
      "mp": 112,
      "pa": 5,
      "ma": 9,
      "speed": 8,
      "move": 3,
      "jump": 3,
      "cEv": 7,
      "innate": [
        "Summon Magic"
      ],
      "weapons": {
        "Rod": 60,
        "Staff": 25,
        "Book": 15
      },
      "heads": [
        "Hat"
      ],
      "bodies": [
        "Clothing",
        "Robe"
      ],
      "shield": false,
      "equipArms": {
        "Knife": {
          "Ninja Blade": 36,
          "Knife": 36,
          "Rod": 29
        },
        "Sword": {
          "Sword": 38,
          "Katana": 37,
          "Knight Sword": 25
        },
        "Axe": {
          "Axe": 36,
          "Flail": 36,
          "Staff": 29
        },
        "Polearm": {
          "Pole": 57,
          "Spear": 29,
          "Fabric": 15
        },
        "Bow": {
          "Bow": 50,
          "Crossbow": 50,
          "Bag": 1
        },
        "Gun": {
          "Gun": 43,
          "Book": 29,
          "Harp": 29
        }
      },
      "notes": "Excluding PreferredArms does nothing if you get an EquipWeapon skill, on every class."
    },
    "F": {
      "hp": 117,
      "mp": 119,
      "pa": 4,
      "ma": 12,
      "speed": 8,
      "move": 3,
      "jump": 3,
      "cEv": 7,
      "innate": [
        "Summon Magic"
      ],
      "weapons": {
        "Rod": 60,
        "Staff": 25,
        "Book": 15
      },
      "heads": [
        "Hat"
      ],
      "bodies": [
        "Clothing",
        "Robe"
      ],
      "shield": false,
      "equipArms": {
        "Knife": {
          "Ninja Blade": 36,
          "Knife": 36,
          "Rod": 29
        },
        "Sword": {
          "Sword": 38,
          "Katana": 37,
          "Knight Sword": 25
        },
        "Axe": {
          "Axe": 36,
          "Flail": 36,
          "Staff": 29
        },
        "Polearm": {
          "Pole": 57,
          "Spear": 29,
          "Fabric": 15
        },
        "Bow": {
          "Bow": 50,
          "Crossbow": 50,
          "Bag": 1
        },
        "Gun": {
          "Gun": 43,
          "Book": 29,
          "Harp": 29
        }
      },
      "notes": "Excluding PreferredArms does nothing if you get an EquipWeapon skill, on every class."
    }
  },
  "Thief": {
    "M": {
      "hp": 188,
      "mp": 36,
      "pa": 10,
      "ma": 5,
      "speed": 10,
      "move": 4,
      "jump": 3,
      "cEv": 30,
      "innate": [
        "Steal"
      ],
      "weapons": {
        "Knife": 50,
        "Ninja Blade": 25,
        "Sword": 25
      },
      "heads": [
        "Hat"
      ],
      "bodies": [
        "Clothing"
      ],
      "shield": false,
      "equipArms": {
        "Knife": {
          "Rod": 43,
          "Ninja Blade": 29,
          "Knife": 29
        },
        "Sword": {
          "Katana": 38,
          "Knight Sword": 33,
          "Sword": 29
        },
        "Axe": {
          "Axe": 36,
          "Flail": 36,
          "Staff": 29
        },
        "Polearm": {
          "Spear": 57,
          "Pole": 29,
          "Fabric": 15
        },
        "Bow": {
          "Bow": 50,
          "Crossbow": 50,
          "Bag": 1
        },
        "Gun": {
          "Gun": 57,
          "Book": 29,
          "Harp": 15
        }
      },
      "notes": "Equip Gun, forced. Guns (62%), Books (25%), Harps (14%)."
    },
    "F": {
      "hp": 176,
      "mp": 39,
      "pa": 8,
      "ma": 7,
      "speed": 10,
      "move": 4,
      "jump": 3,
      "cEv": 30,
      "innate": [
        "Steal"
      ],
      "weapons": {
        "Knife": 50,
        "Ninja Blade": 25,
        "Sword": 25
      },
      "heads": [
        "Hat"
      ],
      "bodies": [
        "Clothing"
      ],
      "shield": false,
      "equipArms": {
        "Knife": {
          "Rod": 43,
          "Ninja Blade": 29,
          "Knife": 29
        },
        "Sword": {
          "Katana": 38,
          "Knight Sword": 33,
          "Sword": 29
        },
        "Axe": {
          "Axe": 36,
          "Flail": 36,
          "Staff": 29
        },
        "Polearm": {
          "Spear": 57,
          "Pole": 29,
          "Fabric": 15
        },
        "Bow": {
          "Bow": 50,
          "Crossbow": 50,
          "Bag": 1
        },
        "Gun": {
          "Gun": 57,
          "Book": 29,
          "Harp": 15
        }
      },
      "notes": "Equip Gun, forced. Guns (62%), Books (25%), Harps (14%)."
    }
  },
  "Mediator": {
    "M": {
      "hp": 160,
      "mp": 48,
      "pa": 8,
      "ma": 8,
      "speed": 9,
      "move": 3,
      "jump": 3,
      "cEv": 9,
      "innate": [
        "Talk Skill",
        "Monster Talk"
      ],
      "weapons": {
        "Gun": 63,
        "Book": 37
      },
      "heads": [
        "Hat"
      ],
      "bodies": [
        "Clothing",
        "Robe"
      ],
      "shield": false,
      "equipArms": {
        "Knife": {
          "Knife": 43,
          "Ninja Blade": 29,
          "Rod": 29
        },
        "Sword": {
          "Sword": 38,
          "Katana": 37,
          "Knight Sword": 25
        },
        "Axe": {
          "Axe": 36,
          "Flail": 36,
          "Staff": 29
        },
        "Polearm": {
          "Pole": 57,
          "Spear": 29,
          "Fabric": 15
        },
        "Bow": {
          "Crossbow": 64,
          "Bow": 35,
          "Bag": 1
        },
        "Gun": {
          "Harp": 43,
          "Book": 29,
          "Gun": 29
        }
      },
      "notes": "Excluding PreferredArms does nothing if you get an EquipWeapon skill, on every class."
    },
    "F": {
      "hp": 150,
      "mp": 51,
      "pa": 7,
      "ma": 10,
      "speed": 9,
      "move": 3,
      "jump": 3,
      "cEv": 9,
      "innate": [
        "Talk Skill",
        "Monster Talk"
      ],
      "weapons": {
        "Gun": 63,
        "Book": 37
      },
      "heads": [
        "Hat"
      ],
      "bodies": [
        "Clothing",
        "Robe"
      ],
      "shield": false,
      "equipArms": {
        "Knife": {
          "Knife": 43,
          "Ninja Blade": 29,
          "Rod": 29
        },
        "Sword": {
          "Sword": 38,
          "Katana": 37,
          "Knight Sword": 25
        },
        "Axe": {
          "Axe": 36,
          "Flail": 36,
          "Staff": 29
        },
        "Polearm": {
          "Pole": 57,
          "Spear": 29,
          "Fabric": 15
        },
        "Bow": {
          "Crossbow": 64,
          "Bow": 35,
          "Bag": 1
        },
        "Gun": {
          "Harp": 43,
          "Book": 29,
          "Gun": 29
        }
      },
      "notes": "Excluding PreferredArms does nothing if you get an EquipWeapon skill, on every class."
    }
  },
  "Oracle": {
    "M": {
      "hp": 149,
      "mp": 86,
      "pa": 6,
      "ma": 10,
      "speed": 9,
      "move": 3,
      "jump": 3,
      "cEv": 22,
      "innate": [
        "Yin Yang Magic"
      ],
      "weapons": {
        "Pole": 75,
        "Book": 25
      },
      "heads": [
        "Hat"
      ],
      "bodies": [
        "Clothing",
        "Robe"
      ],
      "shield": false,
      "equipArms": {
        "Knife": {
          "Knife": 36,
          "Rod": 36,
          "Ninja Blade": 29
        },
        "Sword": {
          "Sword": 38,
          "Katana": 37,
          "Knight Sword": 25
        },
        "Axe": {
          "Staff": 43,
          "Axe": 29,
          "Flail": 29
        },
        "Polearm": {
          "Spear": 43,
          "Pole": 29,
          "Fabric": 29
        },
        "Bow": {
          "Bow": 50,
          "Crossbow": 50,
          "Bag": 1
        },
        "Gun": {
          "Gun": 43,
          "Book": 29,
          "Harp": 29
        }
      },
      "notes": "Excluding PreferredArms does nothing if you get an EquipWeapon skill, on every class."
    },
    "F": {
      "hp": 139,
      "mp": 92,
      "pa": 5,
      "ma": 12,
      "speed": 9,
      "move": 3,
      "jump": 3,
      "cEv": 22,
      "innate": [
        "Yin Yang Magic"
      ],
      "weapons": {
        "Pole": 75,
        "Book": 25
      },
      "heads": [
        "Hat"
      ],
      "bodies": [
        "Clothing",
        "Robe"
      ],
      "shield": false,
      "equipArms": {
        "Knife": {
          "Knife": 36,
          "Rod": 36,
          "Ninja Blade": 29
        },
        "Sword": {
          "Sword": 38,
          "Katana": 37,
          "Knight Sword": 25
        },
        "Axe": {
          "Staff": 43,
          "Axe": 29,
          "Flail": 29
        },
        "Polearm": {
          "Spear": 43,
          "Pole": 29,
          "Fabric": 29
        },
        "Bow": {
          "Bow": 50,
          "Crossbow": 50,
          "Bag": 1
        },
        "Gun": {
          "Gun": 43,
          "Book": 29,
          "Harp": 29
        }
      },
      "notes": "Excluding PreferredArms does nothing if you get an EquipWeapon skill, on every class."
    }
  },
  "Geomancer": {
    "M": {
      "hp": 155,
      "mp": 78,
      "pa": 12,
      "ma": 8,
      "speed": 8,
      "move": 4,
      "jump": 3,
      "cEv": 11,
      "innate": [
        "Elemental"
      ],
      "weapons": {
        "Axe": 50,
        "Sword": 25,
        "Katana": 25
      },
      "heads": [
        "Hat"
      ],
      "bodies": [
        "Clothing",
        "Robe"
      ],
      "shield": true,
      "equipArms": {
        "Knife": {
          "Ninja Blade": 36,
          "Knife": 36,
          "Rod": 29
        },
        "Sword": {
          "Knight Sword": 36,
          "Sword": 32,
          "Katana": 32
        },
        "Axe": {
          "Flail": 36,
          "Staff": 36,
          "Axe": 29
        },
        "Polearm": {
          "Spear": 43,
          "Pole": 43,
          "Fabric": 15
        },
        "Bow": {
          "Bow": 50,
          "Crossbow": 50,
          "Bag": 1
        },
        "Gun": {
          "Gun": 47,
          "Book": 39,
          "Harp": 15
        }
      },
      "notes": "Excluding PreferredArms does nothing if you get an EquipWeapon skill, on every class."
    },
    "F": {
      "hp": 145,
      "mp": 83,
      "pa": 9,
      "ma": 10,
      "speed": 8,
      "move": 4,
      "jump": 3,
      "cEv": 11,
      "innate": [
        "Elemental"
      ],
      "weapons": {
        "Axe": 50,
        "Sword": 25,
        "Katana": 25
      },
      "heads": [
        "Hat"
      ],
      "bodies": [
        "Clothing",
        "Robe"
      ],
      "shield": true,
      "equipArms": {
        "Knife": {
          "Ninja Blade": 36,
          "Knife": 36,
          "Rod": 29
        },
        "Sword": {
          "Knight Sword": 36,
          "Sword": 32,
          "Katana": 32
        },
        "Axe": {
          "Flail": 36,
          "Staff": 36,
          "Axe": 29
        },
        "Polearm": {
          "Spear": 43,
          "Pole": 43,
          "Fabric": 15
        },
        "Bow": {
          "Bow": 50,
          "Crossbow": 50,
          "Bag": 1
        },
        "Gun": {
          "Gun": 47,
          "Book": 39,
          "Harp": 15
        }
      },
      "notes": "Excluding PreferredArms does nothing if you get an EquipWeapon skill, on every class."
    }
  },
  "Lancer": {
    "M": {
      "hp": 194,
      "mp": 34,
      "pa": 13,
      "ma": 4,
      "speed": 8,
      "move": 3,
      "jump": 4,
      "cEv": 18,
      "innate": [
        "Jump"
      ],
      "weapons": {
        "Spear": 75,
        "Pole": 25
      },
      "heads": [
        "Helmet"
      ],
      "bodies": [
        "Armor",
        "Robe"
      ],
      "shield": true,
      "equipArms": {
        "Knife": {
          "Ninja Blade": 36,
          "Knife": 36,
          "Rod": 29
        },
        "Sword": {
          "Sword": 38,
          "Katana": 37,
          "Knight Sword": 25
        },
        "Axe": {
          "Axe": 36,
          "Flail": 36,
          "Staff": 29
        },
        "Polearm": {
          "Fabric": 43,
          "Pole": 29,
          "Spear": 29
        },
        "Bow": {
          "Bow": 50,
          "Crossbow": 50,
          "Bag": 1
        },
        "Gun": {
          "Gun": 45,
          "Book": 41,
          "Harp": 15
        }
      },
      "notes": "Excluding PreferredArms does nothing if you get an EquipWeapon skill, on every class."
    },
    "F": {
      "hp": 181,
      "mp": 37,
      "pa": 10,
      "ma": 5,
      "speed": 8,
      "move": 3,
      "jump": 4,
      "cEv": 18,
      "innate": [
        "Jump"
      ],
      "weapons": {
        "Spear": 75,
        "Pole": 25
      },
      "heads": [
        "Helmet"
      ],
      "bodies": [
        "Armor",
        "Robe"
      ],
      "shield": true,
      "equipArms": {
        "Knife": {
          "Ninja Blade": 36,
          "Knife": 36,
          "Rod": 29
        },
        "Sword": {
          "Sword": 38,
          "Katana": 37,
          "Knight Sword": 25
        },
        "Axe": {
          "Axe": 36,
          "Flail": 36,
          "Staff": 29
        },
        "Polearm": {
          "Fabric": 43,
          "Pole": 29,
          "Spear": 29
        },
        "Bow": {
          "Bow": 50,
          "Crossbow": 50,
          "Bag": 1
        },
        "Gun": {
          "Gun": 45,
          "Book": 41,
          "Harp": 15
        }
      },
      "notes": "Excluding PreferredArms does nothing if you get an EquipWeapon skill, on every class."
    }
  },
  "Samurai": {
    "M": {
      "hp": 144,
      "mp": 62,
      "pa": 14,
      "ma": 7,
      "speed": 8,
      "move": 3,
      "jump": 3,
      "cEv": 27,
      "innate": [
        "Draw Out"
      ],
      "weapons": {
        "Katana": 75,
        "Spear": 25
      },
      "heads": [
        "Helmet"
      ],
      "bodies": [
        "Armor",
        "Robe"
      ],
      "shield": false,
      "equipArms": {
        "Knife": {
          "Ninja Blade": 43,
          "Rod": 29,
          "Knife": 29
        },
        "Sword": {
          "Sword": 39,
          "Knight Sword": 32,
          "Katana": 28
        },
        "Axe": {
          "Axe": 36,
          "Flail": 36,
          "Staff": 29
        },
        "Polearm": {
          "Pole": 43,
          "Spear": 29,
          "Fabric": 29
        },
        "Bow": {
          "Bow": 64,
          "Crossbow": 35,
          "Bag": 1
        },
        "Gun": {
          "Gun": 45,
          "Book": 41,
          "Harp": 15
        }
      },
      "notes": "Excluding PreferredArms does nothing if you get an EquipWeapon skill, on every class."
    },
    "F": {
      "hp": 135,
      "mp": 66,
      "pa": 11,
      "ma": 9,
      "speed": 8,
      "move": 3,
      "jump": 3,
      "cEv": 27,
      "innate": [
        "Draw Out"
      ],
      "weapons": {
        "Katana": 75,
        "Spear": 25
      },
      "heads": [
        "Helmet"
      ],
      "bodies": [
        "Armor",
        "Robe"
      ],
      "shield": false,
      "equipArms": {
        "Knife": {
          "Ninja Blade": 43,
          "Rod": 29,
          "Knife": 29
        },
        "Sword": {
          "Sword": 39,
          "Knight Sword": 32,
          "Katana": 28
        },
        "Axe": {
          "Axe": 36,
          "Flail": 36,
          "Staff": 29
        },
        "Polearm": {
          "Pole": 43,
          "Spear": 29,
          "Fabric": 29
        },
        "Bow": {
          "Bow": 64,
          "Crossbow": 35,
          "Bag": 1
        },
        "Gun": {
          "Gun": 45,
          "Book": 41,
          "Harp": 15
        }
      },
      "notes": "Excluding PreferredArms does nothing if you get an EquipWeapon skill, on every class."
    }
  },
  "Ninja": {
    "M": {
      "hp": 119,
      "mp": 40,
      "pa": 11,
      "ma": 5,
      "speed": 10,
      "move": 4,
      "jump": 4,
      "cEv": 20,
      "innate": [
        "Throw",
        "Dual Wield"
      ],
      "weapons": {
        "Ninja Blade": 50,
        "Flail": 25,
        "Knife": 25
      },
      "heads": [
        "Hat"
      ],
      "bodies": [
        "Clothing"
      ],
      "shield": false,
      "equipArms": {
        "Knife": {
          "Rod": 46,
          "Ninja Blade": 27,
          "Knife": 27
        },
        "Sword": {
          "Katana": 39,
          "Sword": 37,
          "Knight Sword": 24
        },
        "Axe": {
          "Axe": 36,
          "Staff": 36,
          "Flail": 29
        },
        "Polearm": {
          "Spear": 43,
          "Pole": 43,
          "Fabric": 15
        },
        "Bow": {
          "Bow": 50,
          "Crossbow": 50,
          "Bag": 1
        },
        "Gun": {
          "Book": 57,
          "Gun": 29,
          "Harp": 15
        }
      },
      "notes": "Equip Gun, forced. Books (62%), Guns (25%), Harps (14%)."
    },
    "F": {
      "hp": 112,
      "mp": 43,
      "pa": 9,
      "ma": 6,
      "speed": 10,
      "move": 4,
      "jump": 4,
      "cEv": 20,
      "innate": [
        "Throw",
        "Dual Wield"
      ],
      "weapons": {
        "Ninja Blade": 50,
        "Flail": 25,
        "Knife": 25
      },
      "heads": [
        "Hat"
      ],
      "bodies": [
        "Clothing"
      ],
      "shield": false,
      "equipArms": {
        "Knife": {
          "Rod": 46,
          "Ninja Blade": 27,
          "Knife": 27
        },
        "Sword": {
          "Katana": 39,
          "Sword": 37,
          "Knight Sword": 24
        },
        "Axe": {
          "Axe": 36,
          "Staff": 36,
          "Flail": 29
        },
        "Polearm": {
          "Spear": 43,
          "Pole": 43,
          "Fabric": 15
        },
        "Bow": {
          "Bow": 50,
          "Crossbow": 50,
          "Bag": 1
        },
        "Gun": {
          "Book": 57,
          "Gun": 29,
          "Harp": 15
        }
      },
      "notes": "Equip Gun, forced. Books (62%), Guns (25%), Harps (14%)."
    }
  },
  "Calculator": {
    "M": {
      "hp": 132,
      "mp": 70,
      "pa": 7,
      "ma": 8,
      "speed": 7,
      "move": 3,
      "jump": 3,
      "cEv": 15,
      "innate": [
        "Math Skill"
      ],
      "weapons": {
        "Book": 50,
        "Rod": 25,
        "Pole": 25
      },
      "heads": [
        "Hat"
      ],
      "bodies": [
        "Clothing",
        "Robe"
      ],
      "shield": false,
      "equipArms": {
        "Knife": {
          "Ninja Blade": 36,
          "Knife": 36,
          "Rod": 29
        },
        "Sword": {
          "Sword": 38,
          "Katana": 37,
          "Knight Sword": 25
        },
        "Axe": {
          "Staff": 43,
          "Axe": 29,
          "Flail": 29
        },
        "Polearm": {
          "Spear": 43,
          "Pole": 29,
          "Fabric": 29
        },
        "Bow": {
          "Bow": 50,
          "Crossbow": 50,
          "Bag": 1
        },
        "Gun": {
          "Gun": 43,
          "Book": 29,
          "Harp": 29
        }
      },
      "notes": "Preferred Blue Mage: Flails (35%), Books (30%), Rods (18%), Poles (18%)."
    },
    "F": {
      "hp": 123,
      "mp": 75,
      "pa": 5,
      "ma": 10,
      "speed": 7,
      "move": 3,
      "jump": 3,
      "cEv": 15,
      "innate": [
        "Math Skill"
      ],
      "weapons": {
        "Book": 50,
        "Rod": 25,
        "Pole": 25
      },
      "heads": [
        "Hat"
      ],
      "bodies": [
        "Clothing",
        "Robe"
      ],
      "shield": false,
      "equipArms": {
        "Knife": {
          "Ninja Blade": 36,
          "Knife": 36,
          "Rod": 29
        },
        "Sword": {
          "Sword": 38,
          "Katana": 37,
          "Knight Sword": 25
        },
        "Axe": {
          "Staff": 43,
          "Axe": 29,
          "Flail": 29
        },
        "Polearm": {
          "Spear": 43,
          "Pole": 29,
          "Fabric": 29
        },
        "Bow": {
          "Bow": 50,
          "Crossbow": 50,
          "Bag": 1
        },
        "Gun": {
          "Gun": 43,
          "Book": 29,
          "Harp": 29
        }
      },
      "notes": "Preferred Blue Mage: Flails (35%), Books (30%), Rods (18%), Poles (18%)."
    }
  },
  "Bard": {
    "M": {
      "hp": 153,
      "mp": 57,
      "pa": 8,
      "ma": 9,
      "speed": 9,
      "move": 3,
      "jump": 3,
      "cEv": 13,
      "innate": [
        "Sing"
      ],
      "weapons": {
        "Harp": 75,
        "Bow": 25
      },
      "heads": [
        "Hat"
      ],
      "bodies": [
        "Clothing",
        "Armor"
      ],
      "shield": false,
      "equipArms": {
        "Knife": {
          "Ninja Blade": 36,
          "Knife": 36,
          "Rod": 29
        },
        "Sword": {
          "Sword": 38,
          "Katana": 37,
          "Knight Sword": 25
        },
        "Axe": {
          "Staff": 43,
          "Axe": 29,
          "Flail": 29
        },
        "Polearm": {
          "Spear": 39,
          "Pole": 39,
          "Fabric": 21
        },
        "Bow": {
          "Crossbow": 64,
          "Bow": 35,
          "Bag": 1
        },
        "Gun": {
          "Gun": 44,
          "Book": 42,
          "Harp": 14
        }
      },
      "notes": "Excluding PreferredArms does nothing if you get an EquipWeapon skill, on every class."
    }
  },
  "Dancer": {
    "F": {
      "hp": 157,
      "mp": 53,
      "pa": 8,
      "ma": 9,
      "speed": 9,
      "move": 3,
      "jump": 3,
      "cEv": 13,
      "innate": [
        "Dance"
      ],
      "weapons": {
        "Fabric": 75,
        "Bag": 25,
        "Knife": 2
      },
      "heads": [
        "Hat"
      ],
      "bodies": [
        "Clothing",
        "Robe"
      ],
      "shield": false,
      "equipArms": {
        "Knife": {
          "Ninja Blade": 36,
          "Rod": 36,
          "Knife": 29
        },
        "Sword": {
          "Sword": 38,
          "Katana": 37,
          "Knight Sword": 25
        },
        "Axe": {
          "Axe": 36,
          "Flail": 36,
          "Staff": 29
        },
        "Polearm": {
          "Pole": 57,
          "Spear": 29,
          "Fabric": 15
        },
        "Bow": {
          "Bow": 50,
          "Crossbow": 50,
          "Bag": 1
        },
        "Gun": {
          "Gun": 41,
          "Book": 37,
          "Harp": 21
        }
      },
      "notes": "Excluding PreferredArms does nothing if you get an EquipWeapon skill, on every class."
    }
  },
  "Mime": {
    "M": {
      "hp": 198,
      "mp": 33,
      "pa": 13,
      "ma": 11,
      "speed": 10,
      "move": 3,
      "jump": 4,
      "cEv": 6,
      "innate": [
        "Mimic",
        "Concentrate",
        "Beastmaster",
        "Throw Item",
        "No MP"
      ],
      "weapons": {},
      "heads": [
        "Hat",
        "Helmet"
      ],
      "bodies": [
        "Clothing",
        "Armor",
        "Robe"
      ],
      "shield": true,
      "equipArms": {},
      "notes": "MartialArts is 100% unarmed if you force it, and 50% chance to be unarmed if you get it naturally, on every class.",
      "noWeapons": true
    },
    "F": {
      "hp": 185,
      "mp": 35,
      "pa": 11,
      "ma": 13,
      "speed": 10,
      "move": 3,
      "jump": 4,
      "cEv": 6,
      "innate": [
        "Mimic",
        "Concentrate",
        "Beastmaster",
        "Throw Item",
        "No MP"
      ],
      "weapons": {},
      "heads": [
        "Hat",
        "Helmet"
      ],
      "bodies": [
        "Clothing",
        "Armor",
        "Robe"
      ],
      "shield": true,
      "equipArms": {},
      "notes": "MartialArts is 100% unarmed if you force it, and 50% chance to be unarmed if you get it naturally, on every class.",
      "noWeapons": true
    }
  }
}
